// @flow strict
import * as React from 'react';

// $FlowFixMe[nonstrict-import] - this is otherwise good
import {type InputAndOptionsClassNames} from 'src/components/lib/token-list-input/new-stuff.jsx';

import useI18n from 'src/hooks/useI18n';
import {GenesisTZPicker} from 'src/components/lib/tz';
import {
  customTimezones,
  excludedTimezones,
  unsupportedTimezones,
} from './constants.js';
import {BodySmall} from '@spaced-out/ui-design-system/lib/components/Text';
import classify from '@spaced-out/ui-design-system/lib/utils/classify';

import css from './timezone-picker.css';


type Props = {|
  value: ?string,
  onChange: (tz: string) => mixed,
  classNames?: InputAndOptionsClassNames,
|};

/**
 * This is a wrapper around GenesisTZPicker which provides updated timezones
 */
export const TimezonePicker = ({
  value,
  onChange,
  classNames,
}: Props): React.Node => {
  const {labelI18nInstance} = useI18n();

  const t = labelI18nInstance.t;

  const isUnSupportedTimezone = unsupportedTimezones.includes(value);
  return (
    <div className={classify(css.timezonePicker, classNames?.container)}>
      <GenesisTZPicker
        value={value}
        onChange={onChange}
        classNames={{
          box: classify({[css.error]: isUnSupportedTimezone}),
          ...classNames,
        }}
        customTimezones={customTimezones}
        excludedTimezones={excludedTimezones}
      />
      {isUnSupportedTimezone && (
        <BodySmall color="danger">
          {`${t(
            'This_location_is_not_supported_Please_choose_another_location_in_the_same_timezone',
            'This location is not supported. Please choose another location in the same timezone',
          )}`}
        </BodySmall>
      )}
    </div>
  );
};

export default TimezonePicker;
